import type { ReactElement } from 'react'

import { Flex } from '@twisto/components/atoms/flex'
import { Typography } from '@twisto/components/atoms/typography'
import type { IconComponent } from '@twisto/icons'

import * as styles from './installments-min-due-amount-table.styles'

type Props = {
  children: ReactElement
  icon: IconComponent
}
export const InstallmentMinDueAmountTableRow = ({
  children,
  icon: Icon,
}: Props) => (
  <Flex alignItems="center" css={styles.row} wrap="noWrap">
    <Icon color="gray" size="24" />
    <Typography color="textSecondary" variant="b3">
      {children}
    </Typography>
  </Flex>
)
